import React, { useContext, useEffect } from 'react';

import { fetchAuthSession } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import BdsLoadingFullScreen from '../../../shared/components/v3/BdsLoadingFullScreen/BdsLoadingFullScreen';
import { LOGIN_ROUTE } from '../../../shared/constants/auth';
import { SessionContext } from '../../../shared/context/auth/authContext';
import { TRANSLATIONS_AUTH } from '../../../shared/translations/auth';

import './LoginSSO.scss';

const LoginSSO = () => {
  const { socialLogin, resetError } = useContext(SessionContext);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const checkUser = async (shouldCallSocialLogin = false) => {
    try {
      const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken;
      let email = '';
      let sub = '';
      if (idToken && typeof idToken === 'object' && idToken.payload) {
        email = typeof idToken.payload.email === 'string' ? idToken.payload.email : '';
        sub = typeof idToken.payload.sub === 'string' ? idToken.payload.sub : '';
      }
      if (shouldCallSocialLogin) {
        socialLogin({ email, sub });
      }
    } catch {
      navigate(LOGIN_ROUTE);
    }
  };

  useEffect(() => {
    const unsubscribe = Hub.listen('auth', async ({ payload: { event } }) => {
      switch (event) {
        case 'signedIn':
          await checkUser(true);
          break;
        case 'signInWithRedirect_failure':
          resetError('signInWithRedirect_failure');
          navigate(LOGIN_ROUTE);
          break;
      }
    });

    setTimeout(() => checkUser(), 2500);

    return unsubscribe;
  }, []);

  return (
    <div className="loading-sso-container" data-experience="new">
      <BdsLoadingFullScreen show={true} text={t(TRANSLATIONS_AUTH.loading)} />
    </div>
  );
};

export default LoginSSO;
